function cleanPath(path = "") {
  const normalized = `/${String(path)
    .replace(/\/+/g, "/")
    .replace(/^\/+|\/+$/g, "")}`;

  return normalized === "/" ? normalized : normalized.replace(/\/$/, "");
}

function joinPath(...parts) {
  return cleanPath(parts.filter((part) => part !== undefined && part !== null).join("/"));
}

/** Matches the configured public finder routes without registering global history handlers. */
export function createFinderRoutes({ rootPath, landingPath, resultsPath }) {
  const results = joinPath(rootPath, resultsPath);
  const landing = landingPath === undefined || landingPath === null ? undefined : joinPath(rootPath, landingPath);

  function match(pathname) {
    const path = cleanPath(pathname);

    if (landing && path === landing) {
      return "landing";
    }

    return path === results ? "results" : undefined;
  }

  return Object.freeze({
    match,
    pathFor(route) {
      if (route === "landing" && landing) {
        return landing;
      }

      return route === "results" ? results : undefined;
    },
  });
}
